import { COST_CENTERS } from "..";
import { apiInstance } from "../config/apiInstance";

export type GetCostCenterParams = {
  search?: string;
  page?: number;
  size?: number;
  orderBy?: string;
};

export type CostCenterState = {
  id: number;
  code: string;
  name: string;
};

export type CostCenterHealthServiceProvider = {
  id: number;
  code: string;
  employerIdNumber: string;
  name: string;
  creditor: string;
};

export type CostCenterItem = {
  id: number;
  code: string;
  name: string;
  description: string;
  accountingAccount: string;
  conceptCode: string;
  fundingSource: string;
  state: CostCenterState;
  effectiveStartDate: string;
  effectiveEndDate: string;
};

export type GetCostCenterResponse = {
  content: CostCenterItem[];
  totalElements: number;
  number: number;
  size: number;
  contentSize: number;
};

export const getCostCenter = async (
  params?: GetCostCenterParams,
): Promise<GetCostCenterResponse> => {
  const response = await apiInstance.get<
    Omit<GetCostCenterResponse, "contentSize">
  >(COST_CENTERS, {
    params,
  });

  return {
    ...response.data,
    contentSize: response.data.content.length,
  };
};
